// Contact.js

import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
//import { faAt, faPhone, faMapMarker, faFacebookF } from '@fortawesome/fontawesome-free-solid'
import { faFilePdf, faLink} from '@fortawesome/free-solid-svg-icons'
class Covid19 extends Component {
  render() {
    return (
      <div class="contentView">
      <h2>COVID-19 Information</h2>
      <p  style={{paddingTop: '2rem'}}>The Government of AB Restricitons Exemption Program (REP) is no longer in place.  Please follow all posted guidelines while using the arena</p>
      <div>

      <div style={{paddingBottom: '2rem'}}>
<b>Beiseker Arena</b> is a LiveBarn Venue. If you can’t make it to an event or are uncomfortable visiting the arena in person, you can still stay connected by watching all events Live and On Demand.
<ul>
<li>Live stream events from any LiveBarn venue</li>
<li>Watch On Demand for 30 days</li>
<li>Save and share 30-second highlights</li>
<li>Download entire games/practices</li>
</ul>
LiveBarn is available via a monthly or annual subscription:
<ul>
<li>Save 10% when you use promo code: <b>dd66-72bd</b></li>
<li>Existing subscribers can update their promo code to <b>dd66-72bd</b> within their profile</li>
</ul>
For more information, visit <a href="http://livebarn.com">livebarn.com</a>. Download the <a href="https://apps.apple.com/us/app/livebarn/id1434353736">LiveBarn iOS App</a> for easiest mobile viewing
on Apple devices (Android App coming soon).

      </div>
      <button className='btn btn-info' onClick={this.props.history.goBack}>Back</button>
      </div>
      </div>
    );
  }
}

export default Covid19;




// WEBPACK FOOTER //
// ./src/components/Covid19.js